import { DocumentType, PropertyDocumentTypeValue, PropertyDocumentType } from '../../domain/types';
import { DocumentReferenceType } from '../../domain/types/documentReferenceType';
import { DocumentMetadata, documentMetadata, propertyDocumentMetadata } from '../constants';

export function isMandatory(documentReferenceType: DocumentReferenceType, documentType: DocumentType) {
  return ((documentMetadata[documentReferenceType] as any)[documentType] as DocumentMetadata).mandatory;
}

export function getMandatoryPropertyDocumentTypes(skipAml: boolean) {
  return Object.values(PropertyDocumentTypeValue).filter((documentType) => propertyDocumentMetadata[documentType as PropertyDocumentType].mandatory && (documentType !== PropertyDocumentTypeValue.SELLER_ANTI_MONEY_LAUNDERING || !skipAml));
}
